<script>
	export let imgs;
	import {fade} from 'svelte/transition';
	let lightbox;
	let index = 0;
	import debounce from 'just-debounce-it';
	let imgElements = [];
	function compute_margins(i) {
		let maarij = (lightbox.clientWidth - imgElements[i].width) / 2;
		if(i === 0) {
			if(maarij) {
				imgElements[i].style.marginLeft = maarij + 'px';
			} else {
				imgElements[i].style.marginLeft = null;
			}
		}
		if(i === imgs.length - 1) {
			if(maarij) {
				imgElements[i].style.marginRight = maarij + 'px';
			} else {
				imgElements[i].style.marginRight = null;
			}
		} else if((maarij -= 50) > 0) {
			imgElements[i].style.marginRight = maarij + 'px';
		} else {
			imgElements[i].style.marginRight = null;
		}
		let h = (lightbox.clientHeight - imgElements[i].height) / 2;
		if(h) {
			imgElements[i].style.marginTop = imgElements[i].style.marginBottom = h + 'px';
		} else {
			imgElements[i].style.marginTop = imgElements[i].style.marginBottom = null;
		}
	}
	let oldWidth;
	import { onMount } from 'svelte';
	onMount(() => {
		oldWidth = lightbox.clientWidth;
		let ai = [...imgElements.keys()];
		let interval = setInterval(() => {
			for(let i = ai.length - 1; i >= 0; --i) {
				if(imgElements[ai[i]].width && imgElements[ai[i]].height) {
					compute_margins(ai.splice(i, 1)[0]);
				}
			}
			if(ai.length === 0) {
				clearInterval(interval);
			}
		}, 10)
	})
</script>

<svelte:window
	on:resize={debounce(() => {
		for(let i = 0; i < imgElements.length; ++i) {
			compute_margins(i);
		}
		imgElements[index].scrollIntoView({inline:'center'});
		oldWidth = lightbox.clientWidth;
	}, 100, true)}
/>

<style>
	#lightbox {
		position: fixed;
		background: rgba(0, 0, 0, 0.9);
		overflow-x: auto;
		white-space: nowrap;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		cursor: pointer;
		scroll-snap-type: x mandatory;
		touch-action: pan-x;
	}
	#lightbox > img {
		max-height: 100%;
		vertical-align: top;
		max-width: 98%;
		scroll-snap-align: center;
	}
</style>

<div
	id="lightbox"
	on:click={() => imgs = []}
	on:scroll={debounce(() => {
		if(lightbox.clientWidth === oldWidth) {
			for(let i = 0; i < imgElements.length; ++i) {
				let rekt = imgElements[i].getBoundingClientRect();
				if(rekt.left > 0 && rekt.right < lightbox.clientWidth) {
					index = i;
					break;
				}
			}
		}
	}, 200)}
	bind:this={lightbox}
>
	{#each imgs as img, i}
		<img bind:this={imgElements[i]} src="image/{img}" />
	{/each}
</div>